module.exports = __webpack_public_path__ + "static/img/VI.864741d1.png";